const state = () => ({
  message: "",
  show: false,
});

const mutations = {
  HIDE(state) {
    state.message = "";
    state.show = false;
  },
  SHOW(state, message) {
    state.message = message;
    state.show = true;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
